import Cookie, { CookieAttributes } from 'js-cookie';
import { parseJson } from './parse';
import { clone } from 'lodash';

export function get(name: string): string | undefined {
	return Cookie.get(name);
}

export function set(name: string, value: string, options?: CookieAttributes): void {
	Cookie.set(name, value, requireStrict(options));
}

export function remove(name: string, options?: CookieAttributes): void {
	Cookie.remove(name, requireStrict(options));
}

function requireStrict(options?: CookieAttributes): CookieAttributes {
	options = options || {};
	options.sameSite = 'strict';

	return options;
}

export default class CookieOf<T extends object> { 
	constructor(name: string, defaultValue : T, options?: CookieAttributes) {
		this.name = name;
		this.defaultValue = defaultValue;
		this.options = options;
		this.currentValue = null;
	}
  
	get value(): T {
		if (this.currentValue) {
			return this.currentValue;
		}

		const cookieValue = get(this.name);

		this.currentValue = cookieValue == null
			? this.currentValue = clone(this.defaultValue)
			: parseJson<T>(cookieValue);

		return this.currentValue;
	}

	set value(value : T) {
		const valueString = JSON.stringify(value);
		const defaultString = JSON.stringify(this.defaultValue);

		if (valueString == defaultString) {
			remove(this.name, this.options);
		}
		else {
			set(this.name, valueString, this.options);
		}

		this.currentValue = value;
	}

	update(props: Partial<T>) {
		this.value = {...this.value, ...props};
	}
	
	private name: string;
	private defaultValue: T;
	private options: CookieAttributes;
	private currentValue: T;
}